import React from 'react'
import * as R from 'remeda'

import { useMainQueryCustomerAttributeGroups } from './useMainQueryCustomerAttributeGroups'

export const useMainQueryAvailableCustomerAttributeGroups = () => {
  const customerAttributeGroups = useMainQueryCustomerAttributeGroups()

  return React.useMemo(
    () =>
      R.pipe(
        customerAttributeGroups,
        R.filter(({ customerAttributes }) => 0 < customerAttributes.length),
      ),
    [customerAttributeGroups],
  )
}
